import React, { useState } from 'react';
import './legal-page.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DescriptionIcon from '@mui/icons-material/Description';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import VerifiedIcon from '@mui/icons-material/Verified';

const LegalDocuments = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const documents = [
    {
      title: 'Encumbrance Certificate',
      description: 'A necessary legal document that provides total property ownership with no financial or legal liabilities. We verify encumbrances for the last 30 years to ensure complete title clarity.'
    },
    {
      title: 'Land Purchase Deed',
      description: 'The Sale Deed is an important document which contains the details of land purchase from the party by Developer. The sale deed is usually executed before the sale agreement and after the compliance of the terms and conditions detailed in the sale agreement as agreed to by the individuals concerned.'
    },
    {
      title: 'Land Satbara',
      description: 'The Satbara is simply a revenue document that contains information about the property, such as its size, location, and the land on which it is built, among other things. Hence this is important legal documents for purchase of property.'
    },
    {
      title: 'Development Agreement',
      description: 'The Development Agreement may execute between the Developer & land Lord or any of the individual concerned. This document required to understand the terms & condition set between the Developer & land Lord or any of the individual concerned.'
    },
    {
      title: 'Tri-Party Agreement',
      description: 'The Tri-party agreement may used in the third party purchased land develop by Developer. (Only applicable in some of government hold lands.)'
    },
    {
      title: 'Building Approvals',
      description: 'Before commencing construction, the Developer must get the requisite sanctions under the terms of the Building Bylaws, Master Plan, and Local Body Acts. A common mistake made by first-time home buyers is failing to ensure that the Developer follows the terms and conditions of the Building Plan and Layout Approval before purchasing the house.'
    },
    {
      title: 'Commencement Certificate',
      description: 'The certificate is approved by the concerned authorities to start the construction. We verify this certificate to ensure legal commencement of construction work.'
    },
    {
      title: 'Building Approved Plans',
      description: 'The Plans (Building Layout & Floor Plan) are approved by the concerned authorities to start the construction. We verify these plans against the actual construction to ensure compliance.'
    },
    {
      title: 'Aviation NOC',
      description: 'The Certificate required for Height Clearance of the Building from aviation authorities. Essential for high-rise buildings to ensure no airspace violations.'
    },
    {
      title: 'Fire NOC',
      description: 'The Certificate required before start the Building Construction to ensure compliance with fire safety regulations and building codes.'
    },
    {
      title: 'Environmental Clearance Certificate',
      description: 'The Certificate required before start the Building Construction to ensure environmental compliance and sustainability standards.'
    },
    {
      title: 'Allotment Letter',
      description: 'The said letter indicates the confirmation of the details of Purchased flat. Buyer must have get this legal document when purchasing home or property. We verify this letter for accuracy and completeness.'
    },
    {
      title: 'Agreement for Sale / Sale Deed',
      description: 'The Agreement for Sale, also known as the Sale Deed, contains a set of terms and conditions agreed to by both the buyer and the seller. The agreement would include the agreed-upon price for the flat by both the buyer and the seller.'
    },
    {
      title: 'Architect Completion Letter',
      description: 'The Architect\'s Completion Certificate is required in order to pay the instalment to the Developer. We verify this certificate to ensure proper completion of construction.'
    },
    {
      title: 'The Completion Certificate / Occupancy Certificate',
      description: 'The Completion Certificate or Occupancy Certificate is a document that shows that the building has been examined upon completion and that it complies with all municipal corporation or local development authority rules. This paperwork is required in order to obtain services such as water, power, and drainage.'
    },
    {
      title: 'The Possession Letter',
      description: 'The Possession letter is a document prepared by the developer that specifies the date on which the buyers will take possession of the property. This document is generated in the Developer\'s name after receiving the Completion Certificate.'
    },
    {
      title: 'Car Parking Allotment Letter',
      description: 'Though those who purchased Car Parking may receive an allotment notice for the Car Parking No. We verify this allocation and ensure proper documentation.'
    },
    {
      title: 'Plans & Elevation Drawings',
      description: 'The drawings for the interior of the flat would be essential for an architect or the agency to choose you to design the interior. We verify these plans for accuracy and compliance.'
    }
  ];

  const toggleExpanded = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className="legal-documents-section">
      <div className="legal-documents-container">
        <div className="legal-section-header">
          <div className="legal-section-badge">
            <DescriptionIcon />
            Legal Documents
          </div>
          <h2 className="legal-section-title">
            Essential Legal Documents We Verify
          </h2>
          <p className="legal-section-description">
            Our comprehensive verification covers all critical legal documents required for a secure property purchase. 
            We ensure every document is authentic, legally valid, and properly executed.
          </p>
        </div>

        <div className="documents-grid-wrapper">
          <div className="documents-grid">
            {documents.map((doc, index) => (
              <div 
                key={index} 
                className={`document-card ${expandedIndex === index ? 'expanded' : ''}`}
                onClick={() => toggleExpanded(index)}
              >
                <div className="document-card-header">
                  <div className="document-icon-wrapper">
                    <DescriptionRoundedIcon style={{ fontSize: '32px', color: '#667eea' }} />
                  </div>
                  <h3 className="document-title">{doc.title}</h3>
                </div>
                <div className="document-content">
                  <p className={`document-description ${expandedIndex === index ? 'full-text' : ''}`}>
                    {doc.description}
                  </p>
                  <button className="document-toggle-btn">
                    {expandedIndex === index ? (
                      <>
                        <ExpandLessIcon /> Show Less
                      </>
                    ) : (
                      <>
                        <ExpandMoreIcon /> Read More
                      </>
                    )}
                  </button>
                </div>
                {expandedIndex === index && (
                  <div className="document-expanded-indicator">
                    <VerifiedIcon style={{ fontSize: '16px' }} />
                    <span>Verified</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalDocuments;
